export default __webpack_public_path__ + "1316d5f634f5ddbd2f60ca8f371bb7c9.png";